export const EntryClassifier = {
  NORMAL_TEXT: 1,
  SALUTATION: 2,
  GIBBERISH_TEXT: 3,
};
